module.exports = __webpack_public_path__ + "static/media/viasat-sport.fd72f2ce.png";